import "./App.css";
import LogIn from "./components/LogIn/Login.js";
import Navbar from "./components/Navbar/Navbar.js";
import { Route, Routes } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useEffect, useState } from "react";
import { actionCreators } from "./store/index";

function App() {
  // const [longitude, setlongitude] = useState("");
  // const [latitude, setlatitude] = useState("");
  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(function (position) {
  //       console.log("latitude: " + position.coords.latitude);
  //       setlatitude(position.coords.latitude);
  //       console.log("longitude: " + position.coords.longitude);
  //       setlongitude(position.coords.longitude);
  //     });
  //   } else {
  //     console.log("geolocation is not supported");
  //   }
  // }, []);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const AC = bindActionCreators(actionCreators, dispatch);

  return (
    <div className="App">
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css"
      ></link>
      {/* <a
        target="_blank"
        href={"https://maps.google.com/?q=" + latitude + "," + longitude}
      >
        go
      </a> */}
      <Routes>
        <Route path="/" element={<LogIn />} />
        <Route path="Navbar/*" element={<Navbar />} />
      </Routes>
    </div>
  );
}

export default App;
